import { Button } from '@savvy-kit/components/button';

import type { ButtonCellContentProps } from '../../types/cell-types';

export function ButtonCellContent({ label, ...props }: ButtonCellContentProps) {
  return <Button {...props}>{label}</Button>;
}
